import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { AreaListComponent } from '@fi-app/area/area-list/area-list.component';

export const FiAreaListState: Ng2StateDeclaration = {
    name: FiStateNames.Area.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: AreaListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiAreaListStateResolve_pageTitle],
    },
    data: {
        addSref: FiStateNames.Area.Add,
    },
};

export function FiAreaListStateResolve_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByItem(ObjectTypes.Area);
}
